/**
 * Bounds of `POST /sessions/:id/preview-build-failure`, mirrored from the
 * server (`preview-build-report-bounds.ts` beside the route) because the
 * webapp has no dependency on the server packages. Pinned equal by
 * `tests/architecture/builder-client-mirrors-parity.test.ts`.
 */

/** The route refuses a longer message with a 400; trim rather than lose the report. */
export const PREVIEW_BUILD_FAILURE_MESSAGE_MAX = 2_000;

/**
 * The most the server will backdate an outcome by the client's monotonic
 * elapsed time. The route's schema caps `elapsedMs` here too, so the client
 * clamps before sending — a build that slept past it (laptop lid) still gets
 * its report through, backdated by the cap.
 */
export const PREVIEW_BUILD_FAILURE_ELAPSED_CAP_MS = 120_000;
